import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Col, Row } from "antd";

import EmailForm from "../../common/EmailForm";
import { getEmailHistoryByLeadId } from "../../actionCreator/leadDetailsActionCreator";
import reply from "../../assets/images/lead-management/reply.svg";
import DeleteEmail from "./DeleteEmail";
import { formatMessageTime } from "../../utils/formatMessageTime";

const EmailCard = ({ leadDetail, setViewEmail, data, id, received }) => {
  const dispatch = useDispatch();
  const [htmlString, setHtmlString] = useState("");

  useEffect(() => {
    const fetchHtml = async (fileUrl) => {
      try {
        const response = await fetch(fileUrl);
        const text = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(text, "text/html");

        setHtmlString(doc.body.textContent);
      } catch (error) {
        console.error("Error fetching HTML file:", error);
      }
    };
    fetchHtml(data?.bodyS3Url);
  }, [data]);

  const getInitialsFromEmail = (email) => {
    if (!email) return "";

    const [username] = email.split("@"); // Get part before '@'
    const nameParts = username.split(/[\._\-]/); // Split by dot, underscore, or hyphen

    const initials = nameParts
      .filter(Boolean)
      .slice(0, 2) // Just first and last (if available)
      .map((part) => part.charAt(0).toUpperCase())
      .join("");

    return initials;
  };

  const isClientRevert = data?.sender === leadDetail?.emailId;

  return (
    <Row
      className={
        isClientRevert
          ? "flex-row-reverse justify-content-start"
          : received
            ? "justify-content-end"
            : ""
      }
    >
      <Col xs={1}>
        <p
          className={`user-profile text-uppercase ${isClientRevert ? "bg-10A7A1" : "bg-7d9825"}`}
        >
          {getInitialsFromEmail(data?.sender)}
        </p>
      </Col>
      <Col xs={received ? 20 : 23} className="p-0">
        <div
          class={`chat-card ${isClientRevert ? "chat-card-right" : "chat-card-left"}`}
        >
          <div
            className={`d-flex flex-column ${received ? "bg-FCFCFF" : "bg-white"}`}
            style={{ gap: 3 }}
          >
            <div className="d-flex justify-content-between">
              <span
                className="heading18px fw-semibold cursor-pointer"
                onClick={() => setViewEmail(data)}
              >
                {data?.subject}
              </span>
              <div className="d-flex align-items-center" style={{ gap: 20 }}>
                <EmailForm
                  recipientEmail={leadDetail?.emailId}
                  empId={leadDetail?.employeeId}
                  payload={{
                    messageId: data?.messageId,
                    threadId: data?.threadId,
                    subject: `${received ? "" : "Re:"} ${data?.subject}`,
                  }}
                  callback={() => dispatch(getEmailHistoryByLeadId(id))}
                >
                  <div
                    className="heading13px px-10 border rounded d-flex align-items-center cursor-pointer"
                    style={{ gap: 10 }}
                  >
                    <img
                      src={reply}
                      alt=""
                      className="cursor-pointer"
                      style={{ marginBottom: 2 }}
                    />
                    Reply
                  </div>
                </EmailForm>
                {/* <DeleteEmail id={data?.id} clientId={leadDetail?.id} /> */}
              </div>
            </div>
            <span
              className="heading13px cursor-pointer"
              onClick={() => setViewEmail(data)}
            >
              {formatMessageTime(data?.createdDate)} {data?.sender}
              <>{" > "}</>
              {data?.recipients?.map((d) => d.recipientEmail)}
            </span>
            <span
              className="heading13px truncate-text cursor-pointer fw-medium"
              onClick={() => setViewEmail(data)}
            >
              {htmlString}
            </span>
            <span
              className="heading13px cursor-pointer"
              onClick={() => setViewEmail(data)}
            >
              Lead Name: {leadDetail?.fullname}
            </span>
          </div>
        </div>
      </Col>
    </Row>
  );
};

export default EmailCard;
